export default __webpack_public_path__ + "static/media/SUV-PNG.019b265d.png";